export default __webpack_public_path__ + "static/media/GPS_tracking_filled.2643c80a.svg";